<script>
  export default {
    name: "historyCard",
    props: ["user", "date", "text", "name", "module"],
  };
</script>

<template>
  <div class="historyCard">
    <avatar class="historyCard__avatar" :user="user" />
    <div class="historyCard__content">
      <p class="historyCard__text">
        <span class="historyCard__name">{{ name }}</span>
        {{ text }}
        <span class="historyCard__module"> {{ module }} </span>
      </p>
      <time class="historyCard__date" :datetime="date">{{ date }}</time>
    </div>
  </div>
</template>

<style lang="scss">
  .historyCard {
    width: 100%;
    @include Flex(row, flex-start, center);
    gap: 12px;
    padding: 14px;
    border-radius: 8px;
    background: #f9f9f9;

    &__avatar {
      width: 31px;
      height: 31px;
      border: 2px solid $primary_color;
      border-radius: 50%;
      flex-shrink: 0;
    }

    &__content {
      @include Flex(column, flex-start, flex-start);
      gap: 4px;
    }

    &__name,
    &__module {
      font-size: 16px;
      font-weight: 600;
      color: #212121;
      font-family: $newFont_regular;
    }

    &__text {
      margin: 0;
      font-size: 16px;
      font-family: $newFont_regular;
      color: #1b1b1b;
    }

    &__date {
      font-family: $newFont_regular;
      font-size: 14px;
      font-weight: 400;
      color: #414141;
    }
  }
</style>
